import { Divider, Typography } from "@mui/material"
import type { FC } from "react"

import { FilterCheckbox } from "@/components/common/Filters"
import type { InventoryStatus } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

interface ProductInventoryInventoryStatusFilterProps {
  control: any
  values: InventoryStatus[]
  options: Option<InventoryStatus>[]
  onChange: (values: InventoryStatus[]) => void
}

export const ProductInventoryInventoryStatusFilter: FC<ProductInventoryInventoryStatusFilterProps> = ({
  control,
  values,
  options,
  onChange,
}) => {
  return (
    <div data-testid='product-inventory.inventory-status-filter'>
      <Typography variant='subtitle1' fontWeight={700} className='px-4 py-1.5 text-gray-700'>
        Inventory Status
      </Typography>
      <Divider className='mb-4' />
      <div className='flex flex-col overflow-y-auto px-4'>
        {options.map((option) => (
          <FilterCheckbox
            key={option.value}
            control={control}
            name='inventoryStatuses'
            value={option.value}
            values={values}
            label={option.label}
            onFilterChange={(values) => onChange(values as InventoryStatus[])}
            data-testid={`product-inventory.inventory-status-filter.option-${option.value}`}
          />
        ))}
      </div>
    </div>
  )
}
